import { render, staticRenderFns } from "./raul.vue?vue&type=template&id=b004e530&scoped=true"
var script = {}
import style0 from "./raul.vue?vue&type=style&index=0&id=b004e530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b004e530",
  null
  
)

export default component.exports